// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.main-card[data-v-74759c41] {\r\n  box-shadow: 0px -3px 20px rgba(0, 0, 0, 0.15);\r\n  border-radius: 0.25rem;\r\n  border: none;\n}\r\n", ""]);
// Exports
module.exports = exports;
